import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '@/api/client';
import { DemoLayout } from '@/components/DemoLayout';
import { EnrollStepper } from '@/components/EnrollStepper';
import { writeEnrollment } from '@/lib/enrollment';

/**
 * Gate LGPD: nenhuma imagem é processada sem o aceite. O aceite cria o
 * registro (guest `is_demo`) — ele precisa existir antes da selfie porque a
 * indexação da face aponta para `guests.id`.
 */
export function ConsentPage() {
  const navigate = useNavigate();
  const [accepted, setAccepted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleContinue = async () => {
    setSubmitting(true);
    setError(null);
    try {
      const { enrollmentId } = await api.enroll.start();
      writeEnrollment({ enrollmentId, selfieDone: false, indexJobId: null });
      navigate('/cadastrar/selfie');
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Não foi possível iniciar o cadastro.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <DemoLayout backTo="/" title="Cadastro">
      <EnrollStepper current="consent" />
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        <Typography variant="h1">Antes de começar</Typography>
        <Typography color="text.secondary">
          Vamos fazer uma prova de vida pela câmera e guardar um modelo matemático do seu
          rosto para reconhecê-lo depois. Seus dados ficam marcados como demonstração e
          podem ser apagados a qualquer momento.
        </Typography>
      </Box>

      <Box className="result-card">
        <Typography variant="body2" color="text.secondary">
          O que é coletado: imagem do rosto (prova de vida), nome, e-mail, data de nascimento,
          nacionalidade e documento. O documento é guardado cifrado e sempre exibido com máscara.
        </Typography>
        <FormControlLabel
          control={<Checkbox checked={accepted} onChange={(e) => setAccepted(e.target.checked)} />}
          label="Li e autorizo o uso da minha imagem e dados para esta demonstração."
        />
      </Box>

      {error && (
        <Typography color="error" role="alert">
          {error}
        </Typography>
      )}

      <Box sx={{ mt: 'auto', pb: 2 }}>
        <Button variant="contained" fullWidth disabled={!accepted || submitting} onClick={handleContinue}>
          {submitting ? 'Iniciando…' : 'Continuar para a selfie'}
        </Button>
      </Box>
    </DemoLayout>
  );
}
